// extracted by mini-css-extract-plugin
export default {"quiz_question":"uZ","question_subheader":"vZ","why_popup":"wZ","why_underline":"xZ","MyClassEnterDone":"yZ","WhyAskEnterDone":"zZ","WhyUnderlineEnterDone":"AZ","main_question":"BZ"};
    if(module.hot) {
      // 1713361654682
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  